import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../api/Axios"; // Use your configured axios instance

const VerifyEmailPage = () => {
  const { uid, token } = useParams();
  const [status, setStatus] = useState("Verifying...");

  useEffect(() => {
    axios
      .get(`/accounts/verify-email/${uid}/${token}/`)
      .then(() => setStatus("Your email has been verified! You may now log in."))
      .catch(() => setStatus("Verification failed. The link may be invalid or expired."));
  }, [uid, token]);

  return (
    <div className="container py-5">
      <div className="alert alert-info text-center" style={{ maxWidth: 500, margin: "0 auto" }}>
        {status}
      </div>
    </div>
  );
};

export default VerifyEmailPage;